module.exports = __webpack_public_path__ + "static/media/star.532e2138.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/star.png
// module id = 895
// module chunks = 0